/**
 * Global namespace for components `position-sticky` class.
 */
const positionStickyClass = "position-sticky";
export default positionStickyClass;
